var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('h1',[_vm._v("404 page not found")]),_c('button',{staticClass:"button",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.tryAgain}},[_vm._v("Probeer opnieuw")])])])}
var staticRenderFns = []

export { render, staticRenderFns }